const theme = {
  colors: {
    black: '#2C2C2C',
    dark: '#000000',
    bgMain: '#F9F9F9',
    darkGrey: '#1D1D1D',
    lightGrey: '#85929B',
    grey: '#626262',
    accentGrey: '#676767',
    lightText: '#C4C4C4',
    accentRed: '#F94A32',
    lightAccent: '#FFF1F1',
    bgLight: '#FEFDFD',
    yellow: '#FFDA7C',
    yellowLight: '#FFF7DA',
    white: '#FEFDFD',
    greyLight: '#C6D5DD',
    greyDark: '#EDEDED',
    themeLight: '#FDEAEA',
    bgAccent: '#FFF3F3',
    gradientRed: 'linear-gradient(271.36deg, #F24027 -19.65%, #F98E52 110.94%);',
    green: '#34BC52',
    darkbtn: '#3B3E45'
  },
  borders: {
    tableBorder: '1px solid #E3E3E3',
    textInput: '1px solid #C6D5DD',
    checkbox: '1px solid #D8D8D8',
    checkboxChecked: '1px solid #F96652',
    avaBorder: '1px solid #C6D5DD',
    calendarBorder: '1px solid #C4C4C4',
    selectBorder: '1px solid #d1d1d1'
  },
  fonts: {
    main: 'Montserrat'
  }
};

export default theme;
